import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function Origins({data}){

    const items = Array.isArray(data) ? data : []

    return <>

        <Typography variant='h3'>Provenances des utilisateurs</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Provenance</TableCell>
                        <TableCell>Inscriptions Gratuites</TableCell>
                        <TableCell>Inscriptions Payantes</TableCell>
                        <TableCell>CA</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(i => 
                        <TableRow key={i.origin}>
                            <TableCell>{i.origin}</TableCell>
                            <TableCell>{i.free.toLocaleString()}</TableCell>
                            <TableCell>{i.paid.toLocaleString()}</TableCell>
                            <TableCell>{i.revenue.toLocaleString()}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>

    </>

}